import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { PseComponent } from './components/pse/pse.component';
import { CashComponent } from './components/cash/cash.component';
import { ReturnComponent } from './components/return/return.component';
import { ErrorComponent } from './components/error/error.component';
import { AlertpseComponent } from './components/alertpse/alertpse.component';
import { CheckOrderStatusComponent } from './components/wallet-claro-pay/check-order-status/check-order-status.component';
import { VoucherTemplateComponent } from './components/native-daviplata/voucher-template/voucher-template.component';
import { PopupRedirectComponent } from './components/popup-redirect/popup-redirect.component';
import { TransfiyaVoucherComponent } from './components/embebed-transfiya/transfiya-voucher/transfiya-voucher.component';
import { ApiPayInVoucherComponent } from './components/embebed-api-pay-in/embebed-api-pay-in-voucher/api-pay-in-voucher.component';
import { WhiteBrandVoucherComponent } from './components/white-brand-voucher/white-brand-voucher.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'checkout/order', component: HomeComponent },
  { path: 'cc', component: CreditCardComponent },
  { path: 'pse', component: PseComponent },
  { path: 'bank', component: CashComponent },
  { path: 'checkout/alertpse', component: AlertpseComponent },
  { path: 'checkout/alertBE', component: ReturnComponent },
  { path: 'checkout/alertTC', component: ReturnComponent },
  { path: 'checkout/checkOrderStatus', component: CheckOrderStatusComponent },
  { path: 'checkout/voucher', component: VoucherTemplateComponent },
  { path: 'checkout/whiteVoucher', component: WhiteBrandVoucherComponent },
  { path: 'popup-service', component: PopupRedirectComponent },
  { path: 'transfiya/alert', component: TransfiyaVoucherComponent },
  { path: 'dp/transaction/voucher', component: ApiPayInVoucherComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
